:host {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  position: relative;
  width: initial;
  box-sizing: border-box;
  --date-range-inputs-spacing: calc(2 * var(--spacer)) calc(6 * var(--spacer));
  --wrapper-spacing: 0 calc(6 * var(--spacer));
  --actions-spacing: calc(2 * var(--spacer)) calc(6 * var(--spacer));
}

.content-wrapper {
  padding: calc(2.5 * var(--spacer));
}

.calendar-wrapper {
  display: inline-flex;
  justify-content: center;
  position: relative;
  flex-direction: row;
  margin-top: 4px;
  margin-bottom: calc(2.5 * var(--spacer));
}

.calendar-actions {
  display: flex;
  justify-content: flex-end;

  .footer-item {
    margin-left: calc(2 * var(--spacer));
    margin-top: -2px;
  }
}

#firstDatePicker {
  margin-right: calc(4 * var(--spacer));
}

:host([showTimePickers]) {
  .calendar-date-range-inputs {
    display: flex;
    margin-top: -20px;
    margin-bottom: var(--spacer);
  }

  .calendar-wrapper {
    margin-top: 0;
  }
}

.calendar-date-range-inputs {
  display: none;
  justify-content: space-between;
  padding-top: var(--spacer);

  .inputs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &.compact {
      gz-input {
        width: 104px;
        min-width: 104px;
        margin-right: var(--spacer);
      }

      .hour-control {
        width: 184px;
      }

      .left-range-input {
        margin-right: 3px;
      }

      .right-range-input {
        margin-left: 3px;
      }
    }
  }

  .date-range-inputs-block {
    flex: 1;

    .label {
      font-family: var(--font-family-secondary);
      font-size: var(--body-size-medium);
      margin-bottom: 4px;
      color: var(--body-text-arrows-400);
    }

    .hour-control {
      display: flex;
      width: 160px;
      justify-content: space-between;
      align-items: center;
      color: var(--body-text-arrows-400);
    }

    &:first-of-type {
      margin-right: calc(2 * var(--spacer));
    }
    &:last-of-type {
      padding-left: calc(2 * var(--spacer));
    }

    .left-range-input {
      margin-right: 5px;
    }

    .right-range-input {
      margin-left: 5px;
    }
  }
}
